/**
 * ADN Local FanFest — central brand configuration.
 *
 * ONE FILE to change when running a rebrand, seasonal campaign
 * (Jaguars, Holidays, Restaurant Week, 4th of July, etc.), or a full
 * white-label swap. Update the values here, run `yarn build`, redeploy.
 *
 * IMPORTANT: colors are ALSO defined in `src/index.css` as CSS variables
 * (Tailwind consumes those). Keep both in sync.
 */

export const BRAND = {
  // Product identity
  name: "ADN Local FanFest",
  shortName: "FanFest",
  legalOwner: "ADN Local, LLC",
  tagline: "Watch. Check In. Win.",
  motto: "Support Local. Win Big. Build Community.",

  // Description used as the default SEO meta description
  description:
    "ADN Local FanFest — Jacksonville's citywide 2026 World Cup watch-party sweepstakes. Watch. Check In. Win. Free to enter, no purchase necessary, must be 18+.",

  // Geo
  city: "Jacksonville",
  state: "FL",
  region: "US-FL",
  country: "US",

  // Public URLs (production canonical origin)
  origin: "https://myadnlocal.com",
  supportEmail: "support@myadnlocal.com",

  // Footer credit — who built / maintains the platform
  poweredBy: {
    name: "TechTronicsMedia.com",
    url: "https://techtronicsmedia.com",
  },

  // Brand palette (mirrors CSS variables in src/index.css)
  colors: {
    primary: "#00d37f",     // ADN green
    secondary: "#facc15",   // Yellow accent
    background: "#070c1a",  // Deep navy
  },

  // Social handles (leave empty string to hide from footer/SEO)
  social: {
    facebook: "",
    instagram: "",
    twitter: "",
    tiktok: "",
    youtube: "",
  },

  // Campaign identity — active sweepstakes marketing copy
  campaign: {
    displayName: "ADN Local FanFest Jacksonville — 2026 World Cup Watch Party",
    startDate: "2026-07-06",
    endDate: "2026-07-19",
    grandPrizeDate: "2026-07-19",
    grandPrize: {
      shortName: "Cancun Grand Prize",
      description:
        "6 days / 5 nights in Cancun for two with roundtrip airfare + $500 cash",
      arv: 2999,
    },
  },
};

export default BRAND;
